import { useEffect, useState } from "react";
import type { AuthProvider } from "ra-core";
import { CRM } from "@/components/atomic-crm/root/CRM";
import { chargerMoi, creerFournisseurs, type Moi } from "@/components/atomic-crm/providers/atelier";
import type { CrmDataProvider } from "@/components/atomic-crm/providers/types";
import { MoiContext } from "@/atelier/moi";

/**
 * CRM d'Atelier Augmenté (crm.atelieraugmente.fr), bâti sur Atomic CRM (Marmelab, licence MIT).
 * Connexion : lien magique du CRM (page /connexion, cookie partagé avec le tableau de bord).
 */
const App = () => {
  const [etat, setEtat] = useState<{ moi: Moi; dataProvider: CrmDataProvider; authProvider: AuthProvider } | null>(null);
  const [erreur, setErreur] = useState<string | null>(null);
  useEffect(() => {
    chargerMoi()
      .then(async (moi) => {
        if (!moi) { window.location.href = "/connexion"; return; }
        const f = await creerFournisseurs(moi);
        setEtat({ moi, ...f });
      })
      .catch((e) => setErreur(e.message));
  }, []);
  if (erreur) return <p style={{ padding: 24, fontFamily: "Arial" }}>Le CRM n'a pas pu se charger : {erreur}. Rechargez la page.</p>;
  if (!etat) return <p style={{ padding: 24, fontFamily: "Arial" }}>Chargement du CRM…</p>;
  return (
    <MoiContext.Provider value={etat.moi}>
      <CRM dataProvider={etat.dataProvider} authProvider={etat.authProvider} disableTelemetry title="Atelier Augmenté" currency="EUR" />
    </MoiContext.Provider>
  );
};

export default App;
